export default __webpack_public_path__ + "static/4-36304c4540604d99062d44476e47662c.jpg";